import 'core-js/modules/es.array.concat';
import 'core-js/modules/es.array.filter';
import 'core-js/modules/es.array.includes';
import 'core-js/modules/es.array.iterator';
import 'core-js/modules/es.array.map';
import 'core-js/modules/es.function.name';
import 'core-js/modules/es.object.entries';
import 'core-js/modules/es.object.from-entries';
import 'core-js/modules/es.object.keys';
import 'core-js/modules/es.object.to-string';
import 'core-js/modules/es.promise';
import 'core-js/modules/es.regexp.exec';
import 'core-js/modules/es.string.includes';
import 'core-js/modules/es.string.iterator';
import 'core-js/modules/es.string.replace';
import 'core-js/modules/es.string.split';
import 'core-js/modules/web.dom-collections.for-each';
import 'core-js/modules/web.dom-collections.iterator';
import 'regenerator-runtime/runtime';
import { WorldReady } from '@paypalcorp/worldready-core';
import { assert, assertType } from 'yaassertion';
import semverMajor from 'semver/functions/major';
import fetch from 'node-fetch';

function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function () {
    return !!t;
  })();
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function (t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(Wrapper, t);
  }, _wrapNativeSuper(t);
}

var version = "8.1.1";
var WORLDREADY_CDN_NAMESPACE = "worldready-i18n-metadata";
var LIVE_CDN_BASE_URL = "https://www.paypalobjects.com";
var CDN_LIVE_WORLDREADY_BASE_URL = LIVE_CDN_BASE_URL + "/" + WORLDREADY_CDN_NAMESPACE;
var getLiveCDNURL = function getLiveCDNURL(version) {
  if (!version) {
    return "" + CDN_LIVE_WORLDREADY_BASE_URL;
  }
  return CDN_LIVE_WORLDREADY_BASE_URL + "/" + version;
};

/**
 * Given a locale, it  will return certain old locales to new form
 * @param {locale} locale to replace
 * @return {new_locale}
 */
function normalizeLocale(locale) {
  // prettier-ignore
  return locale.replace(/\bno\b/, "nb").replace(/\btl\b/, "fil");
}

/**
 * Function that normalizes locale according to paypal standards. It performs the following operations on locale:
 * 1) replaces '_' with '-' in locale string. E.g., 'en_US' will be replaced with 'en-US'
 * 2) replaces 'C2' with 'CN-xbord'. E.g., 'en-C2' will be 'en-CN-xbord'
 * 3) replaces no with nb
 * 4) replaces tl with fil. E.g., 'tl-PH' will be replaced to 'fil-PH'
 * @param {String} locale bcp-47 locale value (en-US, fr-FR, etc)
 * @param {Object} options an object that can take prop named langSubtag
 * @returns {String} normalized locale value
 */
function _normalizeLocale(locale, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$langSubtag = _ref.langSubtag,
    langSubtag = _ref$langSubtag === void 0 ? true : _ref$langSubtag;
  if (locale.payPalLocaleCode) {
    // A payPalLocaleCode to existing limited locale support.
    var _locale$payPalLocaleC = locale.payPalLocaleCode,
      _locale = _locale$payPalLocaleC.locale,
      _country = _locale$payPalLocaleC.country;
    var _locale$split = _locale.split(/[-_]/),
      _localeLanguage = _locale$split[0];
    locale = _localeLanguage + "-" + _country;

    // A payPalLocaleCode to standard locale normalization: (when PayPal supports all locales anywhere)
    // const { locale: _locale } = locale.payPalLocaleCode;
    // const [_localeLanguage, _localeCountry] = _locale.split(/[-_]/);
    // if (_localeCountry === "XC") {
    //   if (_localeLanguage === "es") {
    //     // es_XC -> es-MX
    //     locale = "es-MX";
    //   } else {
    //     // fr_XC -> fr
    //     // zh_XC -> zh
    //     locale = _localeLanguage;
    //   }
    // } else {
    //   locale = _locale;
    // }
  }
  if (process.env.NODE_ENV !== "production") {
    assert(typeof locale === "string", typeof locale === "object" ? "Invalid locale {{locale}}. Did you mean {{didYouMean}}?" : "Invalid locale {{locale}}", {
      locale: locale,
      didYouMean: {
        payPalLocaleCode: locale
      }
    });
  }
  locale = locale
  // Support both _ & - as locale separator.
  // Note: This must precede other replaces using `\b`.
  .replace(/_/, "-")
  // If locale includes C2, replace it with CN-xbord
  .replace(/\bC2\b/, "CN-xbord");
  if (langSubtag) {
    locale = normalizeLocale(locale);
  }
  return locale;
}
var WorldReadyError = /*#__PURE__*/function (_Error) {
  function WorldReadyError(message) {
    var _this;
    _this = _Error.call(this, message || "") || this;
    _this.code = "WORLDREADY_ERROR";
    return _this;
  }
  _inheritsLoose(WorldReadyError, _Error);
  return WorldReadyError;
}(/*#__PURE__*/_wrapNativeSuper(Error));
var WorldReadyCDNError = /*#__PURE__*/function (_WorldReadyError) {
  function WorldReadyCDNError(errorObj, _ref2) {
    var _this2;
    var code = _ref2.code,
      service = _ref2.service;
    var _ref3 = errorObj || {
        message: "Error while loading metadata from CDN.",
        statusCode: "NA"
      },
      message = _ref3.message,
      statusCode = _ref3.statusCode,
      details = _ref3.details;
    var statusCodeMessage = statusCode && " Status code: " + statusCode || "";
    _this2 = _WorldReadyError.call(this, "" + message + statusCodeMessage) || this;
    _this2.name = _this2.constructor.name;
    _this2.code = code || "WORLDREADY_CDN_ERROR";
    _this2.details = details;
    _this2.statusCode = statusCode;
    _this2.service = service || "NA";
    return _this2;
  }
  _inheritsLoose(WorldReadyCDNError, _WorldReadyError);
  return WorldReadyCDNError;
}(WorldReadyError);
/**
 * Error class to be used when invalid params where passed to a function/method
 */
var InvalidParamsError = /*#__PURE__*/function (_Error2) {
  function InvalidParamsError(message) {
    var _this3;
    _this3 = _Error2.call(this, message || "Invalid params were provided") || this;
    _this3.code = "INVALID_PARAMS";
    return _this3;
  }
  _inheritsLoose(InvalidParamsError, _Error2);
  return InvalidParamsError;
}(/*#__PURE__*/_wrapNativeSuper(Error));
/**
 * Error class that should be used for any non 200 status when implementing requests to services
 */
var RequestError = /*#__PURE__*/function (_Error3) {
  function RequestError(message, errorDetails) {
    var _this4;
    var _ref4 = errorDetails || {},
      statusCode = _ref4.statusCode,
      type = _ref4.type;
    _this4 = _Error3.call(this, message || "Request Error") || this;
    _this4.name = _this4.constructor.name;
    _this4.code = "REQUEST_ERROR";
    _this4.statusCode = statusCode || "NA";
    _this4.type = type || "NA";
    return _this4;
  }
  _inheritsLoose(RequestError, _Error3);
  return RequestError;
}(/*#__PURE__*/_wrapNativeSuper(Error));
function request(_x, _x2) {
  return _request.apply(this, arguments);
} // List of features that are stored on locale folder
function _request() {
  _request = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(url, options) {
    var requestResponse;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return fetch(url, options);
        case 2:
          requestResponse = _context2.sent;
          if (requestResponse) {
            _context2.next = 5;
            break;
          }
          throw new RequestError("Error while performing request to URL=" + url);
        case 5:
          if (!(requestResponse.status !== 200)) {
            _context2.next = 7;
            break;
          }
          throw new RequestError(requestResponse.statusText, {
            statusCode: requestResponse.status,
            type: requestResponse.type
          });
        case 7:
          return _context2.abrupt("return", requestResponse.json());
        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _request.apply(this, arguments);
}
var LOCALE_FEATURES = ["number", "address", "displayName", "currency", "date", "relativeTime", "dateInputMask", "foreignExchange", "plural"];

// List of features that are stored on supplemental folder
var SUPPLEMENTAL_FEATURES = ["address", "name", "phone", "date", "documentIdentifier", "relativeTime", "dateInputMask", "exampleGenerator", "foreignExchange"];

/**
 * Generates URL for object config value
 * if feature is part of noSplitLocaleFeatures, it will return Url based on feature name
 * if feature is NOT part of noSplitLocaleFeatures it will slice metadata and return URL based on slice config
 * features: {
 *  address: {
 *    regions: ["US"]
 *  }
 * }
 * will return https://cdn-latest.static.engineering.dev.paypalinc.com/worldready-i18n-metadata/4.0.0/en-US/address.json
 * features: {
 *  date: {
 *    timezones: ["America/Los_Angelese"]
 *  }
 * }
 * will return 'https://cdn-latest.static.engineering.dev.paypalinc.com/worldready-i18n-metadata/4.0.0/supplemental/date/timezones/America/Los_Angeles.json'
 * @param {Object} featureConfig
 * @param {String} featureKey
 * @param {Array} URLArray
 * @param {String} baseURL
 */
var getUrlForObjectKey = function getUrlForObjectKey(featureConfig, featureKey, URLArray, baseURL) {
  var noSplitLocaleFeatures = ["address", "name", "phone"];
  if (noSplitLocaleFeatures.includes(featureKey) && !baseURL.includes("supplemental")) {
    URLArray.push("" + baseURL + featureKey + ".json");
  } else {
    buildCDNFeatureURL(featureConfig[featureKey], "" + baseURL + featureKey + "/", URLArray);
  }
};

/**
 * Build URL's based on feature configuration set for loadI18nMetadata.
 * @param {Object} featureConfig features configuration used to build CDN URL's
 * @param {String} baseURL base path for final URL
 * @param {Array} URLArray array with all aggregated URL's
 * @returns Array with all CDN URL's to be used to fetch metadata
 */
function buildCDNFeatureURL(featureConfig, baseURL, URLArray) {
  if (baseURL === void 0) {
    baseURL = "";
  }
  if (URLArray === void 0) {
    URLArray = [];
  }
  var _loop = function _loop(featureKey) {
    // in case property is set to false we should ignore that feature
    /**
     * e.g.
     * address:{
     *  recipient: false
     * }
     */
    if (featureConfig[featureKey] === false) {
      return 1; // continue
    }

    // If config value is array and array is empty it will throw.
    if (Array.isArray(featureConfig[featureKey]) && !featureConfig[featureKey].length) {
      throw new InvalidParamsError("Invalid params were provided. Please pass a valid params object in order to load metadata from CDN.");
    }
    if (typeof featureConfig[featureKey] === "object" && !Array.isArray(featureConfig[featureKey]) && featureConfig[featureKey] !== null) {
      getUrlForObjectKey(featureConfig, featureKey, URLArray, baseURL);
    } else if (Array.isArray(featureConfig[featureKey])) {
      featureConfig[featureKey].forEach(function (item) {
        if (typeof item === "object" && !Array.isArray(item)) {
          buildCDNFeatureURL(item, "" + baseURL + featureKey + "/", URLArray);
        } else {
          URLArray.push("" + baseURL + featureKey + "/" + item + ".json");
        }
      });
    } else if (typeof featureConfig[featureKey] === "boolean") {
      URLArray.push("" + baseURL + featureKey + ".json");
    } else {
      URLArray.push("" + baseURL + featureKey + "/" + featureConfig[featureKey] + ".json");
    }
  };
  for (var featureKey in featureConfig) {
    if (_loop(featureKey)) continue;
  }
  return URLArray;
}

/**
 * Will retrieve all metadata from CDN based on URL's passed.
 * @param {Array} CDNURLPaths List of CDN URL's to fetch metadata.
 * @returns List with all resolved promises which contains actual metadata.
 */
var fetchAllCDNMetadataData = function fetchAllCDNMetadataData(CDNURLPaths) {
  // Map URLs to fetch promises
  var cdnPromises = CDNURLPaths.map(function (url) {
    return request(url);
  });
  // Wait for all promises to resolve
  return Promise.all(cdnPromises);
};

/**
 * Returns CDN URL for relativeTime feature
 * @param {String} locale
 * @param {String} CDN_URL
 * @returns {String} URL for locale specific
 */
var getCDNRelativeTimeURLPaths = function getCDNRelativeTimeURLPaths(locale, CDN_URL) {
  return CDN_URL + "/" + locale + "/relativeTime.json";
};

/**
 * Returns CDN URL for date feature
 * @param {String} locale
 * @param {String} CDN_URL
 * @returns {String} URL for locale specific
 */
var getCDNDateURLPaths = function getCDNDateURLPaths(locale, CDN_URL) {
  return CDN_URL + "/" + locale + "/date.json";
};

/**
 * Will return list of CDN URL's based on WorldReady allowed configuration.
 * {
 * locale: 'en-US'
 * features: {
 *  address: {
 *    regions: ['US']
 *  },
 * }
 * }
 * @param {Object} config configuration passed to loadI18nMetadata function.
 * @param {String} CDN_URL Optional parameter to state CDN base URL, if not passed, it will be internally resolved
 * Optional parameter was added to avoid calling CDN Twice when calling loadI18nMetadat method.
 * @returns Full list or CDN URL's
 * e.g. for above input
 * [
 * https://cdn-latest.static.engineering.dev.paypalinc.com/worldready-i18n-metadata/4.0.0/supplemental/address/regions/US.json
 * ]
 */
var getCDNURLList = function getCDNURLList(config, CDN_URL) {
  var locale = config.locale,
    _config$features = config.features,
    features = _config$features === void 0 ? {} : _config$features;

  /**
   * This will be executed when calling this function from app
   */
  if (!CDN_URL) {
    var cdnMajorVersion = semverMajor(version);
    CDN_URL = getLiveCDNURL(cdnMajorVersion);
  }
  var normalizedLocale = _normalizeLocale(locale);

  /**
   * When no metadata slicing config was passed
   * it will serve locale specific + supplemental metadata files
   */
  if (!Object.keys(features).length) {
    return [CDN_URL + "/" + normalizedLocale + ".json", CDN_URL + "/supplemental.json"];
  }
  var featuresWithCustomLocaleSlicing = ["date", "relativeTime"];

  /**
   * date and relativeTime has different split process
   * due to the number of files that needs to be generated,
   * hence excluding those values
   */
  var localeSpecificFeaturesConfig = Object.fromEntries(Object.entries(features).filter(function (_ref5) {
    var key = _ref5[0];
    return LOCALE_FEATURES.includes(key) && !featuresWithCustomLocaleSlicing.includes(key);
  }));

  /**
   * For supplemental data configuration
   */
  var supplementalSpecificFeaturesConfig = Object.fromEntries(Object.entries(features).filter(function (_ref6) {
    var key = _ref6[0];
    return SUPPLEMENTAL_FEATURES.includes(key);
  }));

  // It will generate URL's for locale features only when feature has locale specific metadata
  var CDNLocaleURLPaths = [];
  if (Object.keys(localeSpecificFeaturesConfig).length) {
    CDNLocaleURLPaths = buildCDNFeatureURL(localeSpecificFeaturesConfig, CDN_URL + "/" + normalizedLocale + "/");
  }

  // It will generate URL's for supplemental features only when feature has supplemental specific metadata
  var CDNSupplementalURLPaths = [];
  if (Object.keys(supplementalSpecificFeaturesConfig).length) {
    CDNSupplementalURLPaths = buildCDNFeatureURL(supplementalSpecificFeaturesConfig, CDN_URL + "/supplemental/");
  }
  var CDNCustomURLPaths = [];
  if (Object.keys(features).includes("relativeTime")) {
    CDNCustomURLPaths.push(getCDNRelativeTimeURLPaths(normalizedLocale, CDN_URL));
  }
  if (Object.keys(features).includes("date")) {
    CDNCustomURLPaths.push(getCDNDateURLPaths(normalizedLocale, CDN_URL));
  }
  return [].concat(CDNLocaleURLPaths, CDNCustomURLPaths, CDNSupplementalURLPaths);
};

/**
 * Function to load internationalization metadata from CDN.
 * @param {Object} params an object which should contain following props:
 *  - locale: valid bcp-47 string indicating for which locale should worldready sdk load metadata for
 *      (e.g., en-US, fr-CA, etc.)
 *  - features: will allow slicing metadata based on configuration
 *  - features: {
 *      address: true,
 *    }
 */
var loadI18nMetadata = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(params) {
    var _params, _params$locale, locale, _params$features, features, cdnMajorVersion, CDN_URL, CDNURLPaths, cdnMetadata;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (params === void 0) {
            params = {};
          }
          _params = params, _params$locale = _params.locale, locale = _params$locale === void 0 ? "" : _params$locale, _params$features = _params.features, features = _params$features === void 0 ? {} : _params$features;
          if (locale) {
            _context.next = 4;
            break;
          }
          throw new InvalidParamsError("Invalid params were provided. Please pass a valid params object in order to load metadata from CDN.");
        case 4:
          // Having this assert will be useful if clients pass a non-string value for locale param
          assertType(locale, "locale", ["string"]);
          assertType(features, "features", ["object", "plain object"]);
          cdnMajorVersion = semverMajor(version);
          CDN_URL = getLiveCDNURL(cdnMajorVersion);
          CDNURLPaths = getCDNURLList(params, CDN_URL);
          _context.next = 11;
          return fetchAllCDNMetadataData(CDNURLPaths);
        case 11:
          cdnMetadata = _context.sent;
          _context.prev = 12;
          WorldReady.load.apply(WorldReady, cdnMetadata);
          _context.next = 19;
          break;
        case 16:
          _context.prev = 16;
          _context.t0 = _context["catch"](12);
          throw new WorldReadyCDNError(_context.t0, {
            code: "METADATA_LOAD_ERROR"
          });
        case 19:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[12, 16]]);
  }));
  return function loadI18nMetadata(_x3) {
    return _ref7.apply(this, arguments);
  };
}();

export { getCDNURLList, loadI18nMetadata };
